import { Tabs, styled } from '@mui/material'

export const Root = styled(Tabs)`
  .MuiTabs-indicator {
    background-color: ${props => props.theme.palette.blue[50]};
  }

  .MuiTabScrollButton-root {
    color: ${props => props.theme.palette.gray[50]};

    .MuiSvgIcon-root {
      font-size: 2.2rem;
    }
  }
`
